
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g9PScdC_45T7GzQnVjAokg7Hwwy_45sfMbII8wPWPtokj2TgMeta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexiY5PmyakM4raMbSFP9QXq2hEwkNLqjzSwtqIzQ42_GYMeta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchtYpLRpQ3N0UyyE8JQPMUKjk4TRe9wp50Og_cVP8Rha4Meta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexZEePNROMysFNpGiZyRflH5wT0Kb2QV26E3yv4ZHQyo8Meta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93BzyWCi6ZzQ_45slOh8CI7vXeL6uI1odCoNWNFvVA67VgkMeta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexH_45LuM0MR6_OGlgeux8awjteZ7Pisy4MQi44Pi7rOGkEMeta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93VzG9YSC1d6HlUBBBOaxmUG75DjAWYr74mpu0KU_45yOiAMeta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index8egNHbbfg7QJvTsoxf1jq_5C8VIlrvh7TsfdDsemynQMeta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93HFn0OOOs_Id0v08aURoAmD3NMw_mMLA4mzK2RJsheZcMeta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index0_c8XSAmHoOE9W4AlFYlvJOunWQvt_U2x4ycIwNpREYMeta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexz5BJF_TT4edqbJWIWNzEYcZtpWJ_nRnbkV2a_45WSpx_YMeta } from "/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexH_45LuM0MR6_OGlgeux8awjteZ7Pisy4MQi44Pi7rOGkEMeta || {},
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index8egNHbbfg7QJvTsoxf1jq_5C8VIlrvh7TsfdDsemynQMeta || {},
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index0_c8XSAmHoOE9W4AlFYlvJOunWQvt_U2x4ycIwNpREYMeta || {},
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexz5BJF_TT4edqbJWIWNzEYcZtpWJ_nRnbkV2a_45WSpx_YMeta || {},
    component: () => import("/codebuild/output/src3017414778/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]